export default "__VITE_ASSET__gBoTbhpe__"